export default {
  GET: 'get',
  POST: 'post',
  FORM: 'form' // post && multipart/form-data
}



// WEBPACK FOOTER //
// ./src/scripts/consts/RestMethod.js